// import userEvent from "@testing-library/user-event";
import axios from "axios";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import validatePasswordFormat from "../passwordValidator";

function Register() {
  const mustRedirect = useSelector((state) => state.shoppingCart.mustRedirect);
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [address, setAddress] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [warning, setWarning] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const passwordWarning = "The password provided does not adhere to the format we require.";

  const handlePasswordChange = (ev) => {
    if (warning === passwordWarning) {
      setWarning(null);
    }
    setPassword(ev.target.value);
  };
  const handleSubmit = async (ev) => {
    ev.preventDefault();
    if (
      firstname === "" ||
      lastname === "" ||
      phoneNumber === "" ||
      address === "" ||
      email === ""
    ) {
      setWarning("Please complete all the fields.");
    } else if (!validatePasswordFormat(password)) {
      setWarning(passwordWarning);
    } else {
      try {
        const response = await axios({
          method: "post",
          url: `${process.env.REACT_APP_API_URL}/customers`,
          data: { firstname, lastname, phoneNumber, address, email, password },
        });
        console.log(response.data.customer);
        dispatch({ type: "LOGIN", payload: response.data.store });
        navigate(mustRedirect ? "/checkout/1" : "/");
      } catch (error) {
        console.log(error);
        setWarning("An error has ocurred and your information could not be processed. Try again.");
      }
      navigate("/");
    }
  };

  return (
    <div className="card border-0 shadow-lg rounded-3 initiate-session-panel">
      <div className="card-body p-5">
        <form
          onSubmit={(e) => {
            handleSubmit(e);
          }}
        >
          <h1 className="fs-2">Register</h1>
          <div className="row mt-4">
            <div className="col-sm-12 col-md-6 mb-3">
              <label htmlFor="firstname" className="form-label">
                Firstname
              </label>
              <input
                type="text"
                className="form-control"
                id="firstname"
                aria-describedby="firstname"
                value={firstname}
                placeholder="Firstname"
                onChange={(ev) => {
                  setFirstname(ev.target.value);
                }}
              />
            </div>

            <div className="col-sm-12 col-md-6 mb-3">
              <label htmlFor="lastname" className="form-label">
                Lastname
              </label>
              <input
                type="text"
                className="form-control"
                id="lastname"
                aria-describedby="lastname"
                value={lastname}
                placeholder="Lastname"
                onChange={(ev) => {
                  setLastname(ev.target.value);
                }}
              />
            </div>

            <div className="col-sm-12 col-md-6 mb-3">
              <label htmlFor="phoneNumber" className="form-label">
                PhoneNumber
              </label>
              <input
                type="text"
                className="form-control"
                id="phoneNumber"
                aria-describedby="phoneNumber"
                value={phoneNumber}
                placeholder="PhoneNumber"
                onChange={(ev) => {
                  setPhoneNumber(ev.target.value);
                }}
              />
            </div>

            <div className="col-sm-12 col-md-6 mb-3">
              <label htmlFor="address" className="form-label">
                Address
              </label>
              <input
                type="text"
                className="form-control"
                id="address"
                aria-describedby="address"
                value={address}
                placeholder="Address"
                onChange={(ev) => {
                  setAddress(ev.target.value);
                }}
              />
            </div>

            <div className="col-sm-12 col-md-6 mb-3">
              <label htmlFor="email" className="form-label">
                Email
              </label>
              <input
                type="email"
                className="form-control"
                id="email"
                aria-describedby="email"
                value={email}
                placeholder="Email"
                onChange={(ev) => {
                  setEmail(ev.target.value);
                }}
              />
            </div>

            <div className="col-sm-12 col-md-6 mb-3">
              <label htmlFor="password" className="form-label">
                Password*
              </label>
              <input
                type="password"
                className="form-control"
                id="password"
                aria-describedby="password"
                value={password}
                placeholder="Password"
                onChange={handlePasswordChange}
              />
            </div>

            <div className="mb-2 col-12">
              <p style={{ fontSize: "0.8rem" }}>
                (*) Passwords must have more than 7 characters and contain at least one number and
                one letter.
              </p>
            </div>
          </div>

          <button className="btn submit-button mt-3">Register</button>
          {warning && (
            <p className="text-danger mb-0  mt-3 fw-bold" style={{ fontSize: "0.8rem" }}>
              {warning}
            </p>
          )}
        </form>
      </div>
    </div>
  );
}

export default Register;
